import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    CanDeactivateFn,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import Swal from 'sweetalert2';
import { GetContributor, GetTimesheets, GetUncompletedWeeks } from './timesheet.state';
import { TimesheetEditComponent } from './component/timesheet-edit/timesheet-edit.component';
import { PopupService } from '@ed---interne/ng-uui-components';
import { EmploymentStatus, User } from 'src/app/core/models/user.model';
import { AuthState } from 'src/app/core/states/auth.state';

export const onlyProjectLeaderAndAboveGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
    const store = inject(Store);
    const loggedUser: User | null = store.selectSnapshot(AuthState.loggedUser);
    if (!loggedUser) return false;

    return [
        EmploymentStatus.PROJECT_LEADER,
        EmploymentStatus.ACTIVITY_LEADER,
        EmploymentStatus.DIRECTOR,
    ].includes(loggedUser.employmentStatus);
};

export const timesheetGuard: CanActivateFn = (next: ActivatedRouteSnapshot): boolean | UrlTree => {
    const store = inject(Store);

    //Get timesheet
    const userId = next.params['userid'];
    const fromStr: string = next.params['from'];
    let from: Date | undefined = undefined;
    if (fromStr) from = new Date(fromStr);
    store.dispatch(new GetTimesheets({ userId, from }));

    return true;
};

export const timesheetMissingWeekGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const store = inject(Store);
    const userId = next.params['userid'];
    store.dispatch(new GetUncompletedWeeks({ userId }));
    return true;
};

export const timesheetContributorGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const store = inject(Store);
    const loggedUser: User | null = store.selectSnapshot(AuthState.loggedUser);
    //Get Contributor
    const userId = next.params['userid'] || loggedUser?.id;
    if (!userId) return false;
    store.dispatch(new GetContributor({ userId }));

    return true;
};

export const timesheetEditingGuard: CanDeactivateFn<TimesheetEditComponent> = (
    component: TimesheetEditComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: { url: string | UrlTree },
): boolean => {
    const popupService = inject(PopupService);
    const router = inject(Router);
    if (component.isEditing) {
        popupService
            .openPopup({
                title: 'Sauvegarde des modifications',
                htmlContent: 'Souhaitez-vous sauvegarder les modifications effectuées ?',
                cancelButtonText: 'Quitter sans sauvegarder',
                confirmButtonText: 'Rester sur cette page',
            })
            .then((result) => {
                if (result.isConfirmed) {
                    return false;
                }
                if (result.dismiss !== Swal.DismissReason.close) {
                    //Do nothing
                    component.isEditing = false;
                    router.navigateByUrl(nextState.url);
                    return true;
                }
                return false;
            });
        return false;
    }
    return true;
};
